export enum TenantType {
    MGT = "MGT",
    WIB = "WIB",
}